import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Game } from 'core/models/game';

@Component({
  selector: 'lms-game-create',
  templateUrl: './game-create.component.html',
  styleUrls: ['./game-create.component.scss']
})
export class GameCreateComponent implements OnInit {
  constructor(public location: Location, public router: Router) {}

  ngOnInit() {}

  onSave(game: Game) {
    this.router.navigate(['/games', game.id], { replaceUrl: true });
  }

  cancel() {
    this.location.back();
  }
}
